import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'profile-pills-tab',
  templateUrl: './profile-pills-tab.component.html',
  styleUrls: ['./profile-pills-tab.component.scss'],
})
export class ProfilePillsTabComponent {
  @Input() loginDetail: any = {};

  constructor(public router: Router) {}

  get profileComplete(): boolean {
    return this.loginDetail?.profile_complete == true;
  }

  get stripeVerified(): boolean {
    return this.loginDetail?.stripe_account_verify == true
      || this.loginDetail?.stripeDetail?.detail_submitted == true;
  }

  isActive(path: string): boolean {
    const url = (this.router.url || '').split('?')[0];
    if (path === '/edit-profile') {
      return url === '/edit-profile' || url === '/editprofile';
    }
    return url === path;
  }

  onDisabledClick(event: Event, allowed: boolean): void {
    if (!allowed) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
